import { render } from "./AssociationPage.vue?vue&type=template&id=04e2258d&scoped=true"
import script from "./AssociationPage.vue?vue&type=script&lang=js"
export * from "./AssociationPage.vue?vue&type=script&lang=js"

import "./AssociationPage.vue?vue&type=style&index=0&id=04e2258d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04e2258d"]])

export default __exports__